<template>
  <div @click="onClose" id="modal_wrap">
    <div class="modal_container">
      <div class="swal2-header">
        <div
          class="swal2-icon swal2-info swal2-animate-info-icon"
          style="display: flex;"
        ></div>
      </div>
      <div class="modal_header">
        <h4>{{ modalData.header }}</h4>
      </div>
      <div class="modal_body">
        <div v-html="modalData.body"></div>
        <div v-if="modalData.inputs" v-for="(input, index) in modalData.inputs">
          <div class="form-group">
            <label for="">{{ input.label }}</label>
            <input
              class="form-control"
              v-model="input.data"
              :placeholder="input.placeholder || ''"
              type="text"
            />
          </div>
        </div>

        <div v-if="modalData.dateSelect">
          <hr/>
          <label for="">{{ modalData.dateSelect.title }}</label>

          <DateSelectProps
            :disabled="true"
            :selectedDate="modalData.dateSelect.date"
            :onSelect="updateSelectedDate"
          />

        </div>

        <div v-if="modalData.checkBox">
          <hr/>
          <div class="form-group">
            <input type="checkbox" v-model="modalData.checkBox.data" id="ch"/>
            <label class="pointer" for="ch">{{
                modalData.checkBox.label
              }}</label>
          </div>
        </div>

        <slot
          :updateCurrency="updateCurrency"
          :updateModalData="updateModalData"
        ></slot>

        <div
          v-if="modalData.errorMessage"
          class="error_messages p-t-10"
          v-html="modalData.errorMessage"
        ></div>
        <div
          v-if="errorMessage"
          class="error_messages p-t-10"
          v-html="errorMessage"
        ></div>
      </div>
      <div class="modal_actions">
        <vue-ladda
          @click="onAccept"
          button-class="btn btn-success"
          data-style="zoom-in"
          :loading="acceptBtnLoading"
        >{{ modalData.acceptBtnText }}
        </vue-ladda>
        <!--                <button @click="onAccept" class="btn btn-success accept_btn">{{modalData.acceptBtnText}}</button>-->
        <button @click="onReject" class="btn btn-default">
          {{ modalData.cancelBtnText || "Отмена" }}
        </button>
      </div>
      <div class="modal_footer"></div>
    </div>
  </div>
</template>
<script>
import VueLadda from "vue-ladda/src/vue-ladda.vue";
import {Datetime} from "vue-datetime";
import DateSelectProps from "@/components/dateSelect/DateSelectProps";
import moment from "moment";

export default {
  components: {
    VueLadda,
    DateSelectProps,
    Datetime
  },
  data() {
    return {
      acceptBtnLoading: false,
      errorMessage: null
    };
  },
  props: [
    "onModalClose",
    "onModalAccept",
    "modalData",
    "validate",
    "dateSelect"
  ],
  watch: {
    modalData() {
      // console.log("changed");
    }
  },
  beforeDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = "auto";
  },
  methods: {
    updateSelectedDate(date) {
      this.modalData.dateSelect.date = moment(date).format('YYYY-MM-DD');
    },
    updateModalData(currencyId, countryId) {
      this.modalData.currencySelected = currencyId;
      this.modalData.countrySelected = countryId;
    },
    updateCurrency() {
      console.log(this.modalData.drugId, currId, countryId);
    },
    onAccept(e) {
      this.errorMessage = null;
      if (this.validate) {
        switch (this.validate) {
          case "cityCurrency":
            if (
              !this.modalData.currencySelected ||
              this.modalData.currencySelected == 0 ||
              this.modalData.countrySelected == 0
            ) {
              this.errorMessage = "<p>Выберите валюту и страну</p>";
              return;
            }
            break;
        }
      }

      let err = false;
      if (this.modalData.inputs) {
        this.modalData.inputs.forEach(i => {
          if ((i.required && !i.data) || (i.required && i.data.length < 4)) {
            this.errorMessage = i.message;
            err = true;
            return;
          }
        });
      }
      if (err) return;

      this.acceptBtnLoading = true;
      this.onModalAccept();
    },
    onReject(e) {
      if (!this.acceptBtnLoading) {
        this.onModalClose();
      }
    },
    onClose(e) {
      if (
        !this.acceptBtnLoading &&
        e.target.id === "modal_wrap" &&
        !this.acceptBtnLoading
      ) {
        this.onModalClose();
      }
    }
  }
};
</script>

<style>
.modal_body p {
  margin-bottom: 2px;
}

#modal_wrap .comments .badge {
  background-color: #d0d0d0;
}

#modal_wrap .comments .badge.active {
  background-color: #006cc7;
  color: white;
}

#modal_wrap .comments {
  padding: 5px;
  border: 1px solid lightblue;
  text-align: left;
}

#modal_wrap .comments .comment .date,
#modal_wrap .comments .comment .author {
  font-size: 10px;
}

#modal_wrap .comments .comment .date {
  text-align: right;
}
</style>

<style scoped>
.swal2-icon {
  margin: 5px 3px !important;
}

.error_messages {
  color: red;
}

.btn {
  margin: 10px;
  padding: 7px 25px;
  font-size: 24px;
}

#modal_wrap {
  display: none;
  position: fixed;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.55);
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal_body {
  z-index: 1;
  justify-content: center;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 1.125em;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  word-wrap: break-word;
}

.modal_header {
  position: relative;
  max-width: 100%;
  margin: 0 0 0.4em;
  padding: 0;
  color: #595959;
  font-size: 1.875em;
  font-weight: 600;
  text-align: center;
  text-transform: none;
  word-wrap: break-word;
}

.modal_actions {
  display: flex;
  z-index: 1;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 1.25em auto 0;
}

.modal_container {
  background-color: white;
  padding: 20px;
  min-width: 500px;
  width: fit-content;
}
</style>
